import { AloBase, getDefaultAloBase } from "./AloBase"
import { AloIconLg, getDefaultAloIconLg } from "./AloIconLg"


export interface AloIcon extends AloBase  {        
    icon:string,
    selectedIcon:string        
    lgs:Array<AloIconLg>
}

export const getDefaultAloIcon = ():AloIcon => {
    return {
        ...getDefaultAloBase(),
        icon:'',
        selectedIcon:'',
        lgs:[getDefaultAloIconLg()]
    }
}